import { Grid, makeStyles } from "@mui/material";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Fab from "@mui/material/Fab";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import HelpIcon from "@mui/icons-material/Help";
import FeedIcon from "@mui/icons-material/Feed";
import PropTypes from "prop-types";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import logonobg from "../assets/file.png";
import logo from "../assets/logo.png";
import logodark from "../assets/logodark.png";
import { Button, Container, Nav, Navbar, Tooltip } from "react-bootstrap";
import { FilterList, HomeMax, LocalHospital, VaccinesOutlined } from "@mui/icons-material";
import aboutbg from "../assets/about.jpg"
import { MDBCol, MDBContainer, MDBFooter, MDBIcon, MDBRow } from "mdb-react-ui-kit";
import Navb from "./Navbar";
export default function About() {
  About.propTypes = {
    post: PropTypes.shape({
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageText: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  };

  const [open, setopen] = useState(false);

  const openNav = (e) => {
    e.preventDefault();
    setopen((prevopen) => !prevopen);
  };

  const [templateParams, setTp] = useState({
    email: "",
    text: "",
  });
  const form = useRef();
  const [sent, setsent] = useState(false);
  const [load, setload] = useState(false);

const [navBackground, setNavBackground] = useState(false);
const navRef = useRef();
navRef.current = navBackground;
useEffect(() => {
  const handleScroll = () => {
    const show = window.scrollY > 50;
    if (navRef.current !== show) {
      setNavBackground(show);
    }
  };
  document.addEventListener("scroll", handleScroll);
  return () => {
    document.removeEventListener("scroll", handleScroll);
  };
}, []);
  return (
    <div>
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito+Sans&family=Nunito:wght@600;700;800&display=swap"
        rel="stylesheet"
      />
      {/* Font Awesome */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css"
        rel="stylesheet"
      />
      {/* Flaticon Font */}
      <link href="lib/flaticon/font/flaticon.css" rel="stylesheet" />
      {/* Libraries Stylesheet */}
      <link
        href="lib/owlcarousel/assets/owl.carousel.min.css"
        rel="stylesheet"
      />
      <link
        href="lib/tempusdominus/css/tempusdominus-bootstrap-4.min.css"
        rel="stylesheet"
      />
      {/* Customized Bootstrap Stylesheet */}
      <link href="css/style.css" rel="stylesheet" />
      {open ? (
        <div className="NavIcon">
          <Box sx={{ "& > :not(style)": { m: 1 } }}>
            <Tooltip title="acceuil" placement="Top">
              <a href="/">
                <Fab color="default" aria-label="add">
                  <HomeMax />
                </Fab>
              </a>
            </Tooltip>
            <Tooltip title="Connexion" placement="Top">
              <a href="/connexion">
                <Fab color="success" aria-label="add">
                  <LoginIcon />
                </Fab>
              </a>
            </Tooltip>
            <Tooltip title="Inscription" placement="Top">
              <a href="/inscription">
                <Fab color="warning">
                  <PersonAddAltIcon />
                </Fab>
              </a>
            </Tooltip>
            <Tooltip title="Catalogue" placement="Top">
              <a href="/Catalogue">
                <Fab color="info" aria-label="add">
                  <FeedIcon />
                </Fab>
              </a>
            </Tooltip>
            <Tooltip title="Comment ca marche?" placement="Top">
              <a href="/about">
                <Fab color="secondary" aria-label="edit">
                  <HelpIcon />
                </Fab>
              </a>
            </Tooltip>
          </Box>
        </div>
      ) : (
        <></>
      )}

     <Navb />

      <Paper
        sx={{
          position: "relative",
          backgroundColor: "grey.800",
          color: "#fff",
          mb: 4,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "500px",
          backgroundPosition: "center",
          backgroundImage: `url(${aboutbg})`,
        }}
      >
        {/* Increase the priority of the hero background image */}

        <Box
          sx={{
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,.3)",
          }}
        />
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box sx={{ marginTop: "50px", textAlign: "center" }}>
              <Typography
                component="h1"
                variant="h3"
                color="inherit"
                gutterBottom
                style={{
                  color: "#CAF0F8",
                  textAlign: "center",
                  fontFamily: " 'Montserrat', Sans-Serif",
                  fontWeight: "bolder",
                  marginTop: "5%",
                }}
              >
                <img src={logonobg} style={{ width: "250px" }} />
              </Typography>
              <span style={{ textAlign: "center" }}>
                Choisissez votre formule d’assurance Auto adaptée à vos besoins
                et à votre budget,en seulement quelques clics
              </span>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Grid
        container
        xs={12}
        style={{
          boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.75)",
          marginTop: "-2%",
          backgroundColor: "white",
        }}
      >
        <Grid sm={4} xs={12}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <MDBIcon fas icon="vials" size="2x" color="info" />{" "}
            </ListItemAvatar>
            <ListItemText
              primary="UN CHOIX RICHE DE GARANTIES"
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    berberberberberber
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </Grid>

        <Grid sm={4} xs={12}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <LocalHospital
                alt="Remy Sharp"
                color="info"
                sx={{ fontSize: "40px" }}
              />
            </ListItemAvatar>
            <ListItemText
              primary="UN CHOIX RICHE DE GARANTIES"
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    berberberberberber
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </Grid>
        <Grid sm={4} xs={12}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <MDBIcon fas icon="user-md" color="info" size="2x" />
            </ListItemAvatar>
            <ListItemText
              primary="UN SERVICE D'ASSISTANCE"
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    INCLUS 24H/24 ET 7J/7 où que vous soyez quand vous voulez
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </Grid>
      </Grid>
      <Grid
        xs={12}
        style={{
          boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.75)",
          backgroundColor: "white",
          padding: "5%",
        }}
      >
        <Typography variant="body1">
          Pour rouler en toute sérénité, Asfelia vous propose l’assurance « Tous
          Risques » offrant une protection à votre véhicule pour le garder comme
          neuf le plus longtemps possible. L’assurance auto Tous risques est la
          formule la plus complète. Elle intervient notamment dans le cas d’un
          accident dit « Responsable », c’est-à-dire si le tort est de votre
          côté, y compris si vous perdez seul le contrôle de votre voiture.
        </Typography>
      </Grid>

      <Grid
        xs={12}
        container
        style={{
          backgroundColor: "white",
          padding: "5%",
        }}
      >
        <Grid xs={6} style={{}}>
          <Typography
            variant="h5"
            style={{
              color: "#03045E",
              fontSize: "3vh",
              fontFamily: " 'Bebas Neue', sans-serif",
            }}
          >
            Ce qu'on vous garantie chez nous
          </Typography>
          <Typography variant="h6" style={{ color: "#96968f" }}>
            Rahima, votre destination de confiance pour la restauration
            capillaire et le renouveau de votre confiance en vous. Située dans
            un cadre paisible et confortable, notre clinique est spécialisée
            dans l'implantation capillaire, offrant des solutions personnalisées
            pour répondre à vos besoins uniques
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ display: "flex", marginTop: "2%" }}
          >
            {" "}
            <p style={{ color: "#03045E", marginRight: "2%" }}>● </p> Rahima
            assure la qualité de ses services en utilisant des équipements de
            pointe et en employant des professionnels qualifiés.
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ display: "flex", marginTop: "1%" }}
          >
            {" "}
            <p style={{ color: "#03045E", marginRight: "2%" }}>● </p> Rahima
            s'engage à garantir la satisfaction de ses clients en offrant un
            service attentionné et en répondant à leurs besoins de manière
            efficace
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ display: "flex", marginTop: "1%" }}
          >
            {" "}
            <p style={{ color: "#03045E", marginRight: "2%" }}>● </p> Rahima
            offre un suivi attentif à ses clients, en les accompagnant tout au
            long de leur parcours médical et en fournissant un soutien continu
            après les traitements ou les consultations.
          </Typography>
        </Grid>

        <Grid xs={12} md={5} lg={5} style={{ marginLeft: "5%" }}>
          <MDBRow>
            <MDBCol lg={4} md={12} className="mb-4 mb-lg-0">
              <img
                src="https://img.freepik.com/free-photo/man-going-through-follicular-unit-extraction-process_23-2149106296.jpg?t=st=1714384386~exp=1714387986~hmac=8b1e1a4ea19c574c5e5f37f9a92df22b3112d388bc75c21b82b757c530210962&w=1380"
                className="w-100 shadow-1-strong rounded mb-4"
                alt="Boat on Calm Water"
              />

              <img
                src="https://img.freepik.com/free-photo/charming-doctor-looking-camera_23-2147771707.jpg?t=st=1714384439~exp=1714388039~hmac=72f943ab4875a3e1f9a31d5895baac3ffcb2c2dcc99f2cbc1d2907ad80ca711b&w=826"
                className="w-100 shadow-1-strong rounded mb-4"
                alt="Wintry Mountain Landscape"
              />
            </MDBCol>

            <MDBCol lg={4} className="mb-4 mb-lg-0">
              <img
                src="https://img.freepik.com/free-photo/science-laboratory-equipment-test-tube-with-blood-healthcare-development-chemical-dripping-pipe-with-glass-flask-analysis-biochemistry-lab-clinic-professional-instruments_482257-27591.jpg?t=st=1714384473~exp=1714388073~hmac=10f29306332a3ccb86310098ad02060bb8ecdb2c0d2d158f6ce75a6171db14cb&w=740"
                className="w-100 shadow-1-strong rounded mb-4"
                alt="Mountains in the Clouds"
              />

              <img
                src="https://img.freepik.com/free-photo/adult-male-getting-hair-loss-treatment_23-2149152777.jpg?t=st=1714384601~exp=1714388201~hmac=1362a0659cb3048e10574a28faf488973b4a939cdbf66387537242d7a38d51bf&w=1380"
                className="w-100 shadow-1-strong rounded mb-4"
                alt="Boat on Calm Water"
              />
            </MDBCol>
          </MDBRow>
        </Grid>
      </Grid>

      <MDBFooter
        bgColor="light"
        className="text-center text-lg-start text-muted"
      >
        <section className="">
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3" style={{ marginTop: "2%" }}>
              <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                <img
                  src={logonobg}
                  style={{ width: "100px", height: "100px" }}
                />
                <h2
                  style={{
                    fontFamily: " 'Bebas Neue', sans-serif",
                    textAlign: "left  ",
                  }}
                >
                  centre de Diagnostic medicale
                </h2>
              </MDBCol>

              <MDBCol
                md="2"
                lg="2"
                xl="2"
                className="mx-auto mb-4"
                style={{ marginTop: "2%" }}
              >
                <h6 className="text-uppercase fw-bold mb-4">Liens Utiles</h6>
                <p>
                  <a href="#!" className="text-reset">
                    TeleConsultation
                  </a>
                </p>
                <p>
                  <a href="#!" className="text-reset">
                    Contact
                  </a>
                </p>
                <p>
                  <a href="#!" className="text-reset">
                    Qui sommes nous ?
                  </a>
                </p>
              </MDBCol>

              <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p>
                  <MDBIcon icon="home" className="me-2" color="info" />
                  Cite Russe N°18 Ouled Yaich, Blida
                </p>
                <p>
                  <MDBIcon icon="envelope" className="me-3" color="info" />
                  cdmrahima@gmail.com
                </p>
                <p>
                  <MDBIcon icon="phone" className="me-3" color="info" /> + 213
                  542 20 99 22
                </p>
                <p>
                  <MDBIcon icon="print" className="me-3" color="info" /> + 01
                  234 567 89
                </p>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
      </MDBFooter>

      {/* <div className="container-fluid bg-dark text-white mt-5 py-5 px-sm-3 px-md-5">
    <div className="row pt-5">
      <div className="col-lg-4 col-md-12 mb-5">
        <h1 className="mb-3 display-5 text-capitalize text-white">Asfaleia</h1>
       
      </div>
      <div className="col-lg-8 col-md-12">
        <div className="row">
          <div className="col-md-4 mb-5">
            <h5 className="text-primary mb-4">Get In Touch</h5>
            <p><i className="fa fa-map-marker-alt mr-2" />xxxxxxxxxxxxxxxxxxxxxx</p>
            <p><i className="fa fa-phone-alt mr-2" />xxxxxxxxxxxxxx</p>
            <p><i className="fa fa-envelope mr-2" />asfaleiaveh@gmail.com</p>
            <div className="d-flex justify-content-start mt-4">
              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0" style={{width: '36px', height: '36px'}} href="#"><i className="fab fa-twitter" /></a>
              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0" style={{width: '36px', height: '36px'}} href="#"><i className="fab fa-facebook-f" /></a>
              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0" style={{width: '36px', height: '36px'}} href="#"><i className="fab fa-linkedin-in" /></a>
              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0" style={{width: '36px', height: '36px'}} href="#"><i className="fab fa-instagram" /></a>
            </div>
          </div>
          <div className="col-md-4 mb-5">
            <h5 className="text-primary mb-4">Popular Links</h5>
            <div className="d-flex flex-column justify-content-start">
              <a className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2" />Home</a>
              <a className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2" />Login</a>
              <a className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2" />SignUp</a>
              
            </div>
          </div>
          <div className="col-md-4 mb-5">
            <h5 className="text-primary mb-4">Contact Us</h5>
            <form ref={form} onSubmit={sendEmail}>
            <div className="form-group">
                <input type="email"        onChange={(e)=>{setTp({...templateParams, email:e.target.value})}} name="user_email" value={templateParams.email} className="form-control border-0" placeholder="Your Email" required="required" />
              </div>
              <div className="form-group">
                <input name="message" onChange={(e)=>{setTp({...templateParams, text:e.target.value})}} className="form-control border-0" value={templateParams.text}  placeholder="Your Message" required="required" />
              </div>
              <div>
                <button className="btn btn-lg btn-primary btn-block border-0"value="Send" type="submit">Submit Now</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div> */}
    </div>
  );
}
